import { FILE_TYPE } from './constants';
export const DOCUMENT_LIKE_FILE_TYPES = [FILE_TYPE.pdf, FILE_TYPE.office, FILE_TYPE.archive];
export const DOCUMENT_LIKE_FILE_TYPES_QUERY = DOCUMENT_LIKE_FILE_TYPES.join(' or ');
export const isDocumentLikeFileType = filetype => DOCUMENT_LIKE_FILE_TYPES.includes(filetype);